import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { IdCard as IdCardIcon, ShieldCheck, Clock } from 'lucide-react';
import { employeeApi } from '../../api/hr';
import { VRI_LOGO_DATA_URI } from '../../assets/logo';
import { PageHeader } from '../../components/PageHeader';

/** View-only, per the explicit rule: staff can never generate/edit their own card - HR/Admin only, via the HR Console. The organisation logo is now real (embedded, no Blob Storage needed); the staff photo placeholder remains, since actual photo upload is still blocked on that same unresolved infrastructure gap. */
export function MyIdCardPage() {
  const profileQuery = useQuery({ queryKey: ['my-profile'], queryFn: () => employeeApi.getMe() });
  const cardQuery = useQuery({ queryKey: ['my-id-card'], queryFn: () => employeeApi.getMyIdCard() });

  const employee = profileQuery.data?.data;
  const card = cardQuery.data?.data;

  return (
    <div className="page">
      <Link to="/staff">&larr; Back to Dashboard</Link>
      <PageHeader title="My ID Card" />

      {!card ? (
        <section className="card placeholder-card">
          <h2><IdCardIcon size={16} className="inline-icon" /> No ID Card Issued Yet</h2>
          <p className="muted">Your ID card has not been generated yet. Contact HR if you believe this is needed.</p>
        </section>
      ) : (
        <section className="card id-card-preview">
          <div className="id-card-visual">
            <div className="id-card-header">
              <img src={VRI_LOGO_DATA_URI} alt="Verdantrise Humanitarian Initiative" className="id-card-logo" />
              <span>VERDANTRISE HUMANITARIAN INITIATIVE</span>
            </div>
            <div className="id-card-body">
              <div className="id-card-photo-placeholder">
                {employee?.profile_photo_data ? <img src={employee.profile_photo_data} alt="Staff" className="id-card-photo-img" /> : <ShieldCheck size={32} />}
              </div>
              <div>
                <div className="id-card-name">{employee?.full_name}</div>
                <div className="id-card-position">{employee?.position_name ?? '-'}</div>
                <div className="id-card-staffid">{employee?.staff_id}</div>
                <div className="muted">{employee?.department_name ?? '-'} · {employee?.duty_station_name ?? '-'}</div>
              </div>
            </div>
            <div className="id-card-footer">
              <span>Issued: {card.issue_date ?? '-'}</span>
              <span>Expires: {card.expiry_date ?? 'N/A'}</span>
            </div>
          </div>
          <p className="muted"><Clock size={13} className="inline-icon" /> Status: {card.status.replace('_', ' ')}</p>
        </section>
      )}
    </div>
  );
}
